import React, { useEffect } from 'react';
import { Dialog, DialogBody, Typography } from '@material-tailwind/react';

const MsgSucess = ({ text, reset, outText }) => {
  const [open, setOpen] = React.useState(false);

  const handleOpen = () => setOpen(!open);

  const handleClose = () => {
    setOpen(false);
    reset();
  };

  useEffect(() => {
    handleOpen();
    return () => setOpen(false);
  }, [text]);

  return (
    <Dialog
      open={open}
      handler={handleClose}
      size="xs"
      animate={{
        mount: { scale: 1, y: 0 },
        unmount: { scale: 0.9, y: -100 },
      }}
      className="p-4 bg-green-100 text-green-800 border border-green-400 rounded-lg shadow-md focus:outline-none"
    >
      <DialogBody className="focus:border-transparent">
        <div className="flex items-center">
          <div className="mr-3">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-6 w-6 text-green-600"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M9 12l2 2 4-4m6 4a9 9 0 11-18 0 9 9 0 0118 0z"
              />
            </svg>
          </div>
          <div>
            <strong>Sucesso!</strong>
            <Typography className="italic font-bold">{text || ''}</Typography>
            <Typography>
              {outText ? outText : 'Seu cadastro foi realizado com sucesso.'}
            </Typography>
          </div>
        </div>
      </DialogBody>
    </Dialog>
  );
};

export default MsgSucess;
